/**
 * Merge consecutive terms for the same president + parish into one timeline row.
 * e.g. "1990 – 1992" + "1992 – 1994" → "1990 – 1994"
 */
export function groupFormerPresidentTerms(items) {
  if (!Array.isArray(items) || !items.length) return [];

  const grouped = [];
  for (const item of items) {
    const name = String(item.name || "").trim();
    const parish = String(item.parish || "").trim();
    const period = String(item.period || "").trim();
    const last = grouped[grouped.length - 1];

    const samePerson =
      last &&
      last.name.toLowerCase() === name.toLowerCase() &&
      last.parish.toLowerCase() === parish.toLowerCase();

    if (samePerson) {
      const start = last.period.split(/[–-]/)[0]?.trim() || last.period;
      const end = period.split(/[–-]/).pop()?.trim() || period;
      last.period = `${start} – ${end}`;
    } else {
      grouped.push({ period, name, parish });
    }
  }

  return grouped;
}
